/* Famgraving — Blog (fg-article.liquid), 30-sep-2026.
   Índice lateral con sección activa, barra de progreso, videos que arrancan al entrar
   en pantalla, numerales de los títulos, tablas y barra fija del celular.
   Las animaciones de entrada (data-fgh-reveal, data-fgh-line) las hace fg-home.js. */
(function () {
  if (window.__fgaInit) return;
  window.__fgaInit = true;

  function slug(t) {
    return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }

  /* true si el elemento es lo primero del bloque (Shopify mete saltos de linea antes del <strong>) */
  function lead(parent, el) {
    var n = parent.firstChild;
    while (n && n !== el) { if (n.nodeType !== 3 || n.textContent.trim()) return false; n = n.nextSibling; }
    return n === el;
  }

  function init() {
    var root = document.querySelector('[data-fga]');
    if (!root) return;
    var main = root.querySelector('.fga-main');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Primer párrafo como entrada */
    var firstP = main.querySelector('.fga-prose > p');
    if (firstP) firstP.classList.add('fga-lead');

    /* "Good for:" → recuadro; listas con negrita al inicio → tarjetas */
    main.querySelectorAll('.fga-prose p').forEach(function (p) {
      var s = p.firstElementChild;
      if (s && s.tagName === 'STRONG' && lead(p, s) && /^good for/i.test(s.textContent)) p.classList.add('fga-goodfor');
    });
    main.querySelectorAll('.fga-prose ul').forEach(function (ul) {
      var lis = ul.children, ok = lis.length >= 2 && lis.length <= 6;
      for (var i = 0; ok && i < lis.length; i++) {
        var f = lis[i].firstElementChild;
        if (!f || f.tagName !== 'STRONG' || !lead(lis[i], f) || lis[i].querySelector('a')) ok = false;
      }
      if (ok) { ul.classList.add('fga-checks'); if (lis.length === 3) ul.classList.add('fga-checks--3'); }
    });

    /* Tablas dentro de un marco con scroll */
    main.querySelectorAll('.fga-prose table').forEach(function (t) {
      var w = document.createElement('div');
      w.className = 'fga-table';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    /* Títulos: ancla, numeral e índice */
    var list = root.querySelector('.fga-toc__list');
    var toc = root.querySelector('[data-fga-toc]');
    var heads = Array.prototype.slice.call(main.querySelectorAll('.fga-prose h2, .fga-faq h2'));
    var links = [];
    heads.forEach(function (h, i) {
      var text = h.getAttribute('data-fga-toc-title') || h.textContent.trim();
      var m = /^(\d+)\.\s+(.*)$/.exec(h.textContent.trim());
      if (m && !h.hasAttribute('data-fga-toc-title')) {
        h.innerHTML = '<span class="fga-num">' + (m[1].length < 2 ? '0' + m[1] : m[1]) + '</span><span>' + m[2] + '</span>';
        text = m[2];
      }
      if (!h.id) h.id = slug(text) || 'section-' + i;
      if (list) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = text;
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
        a.addEventListener('click', function () { if (toc) toc.classList.remove('is-open'); });
      }
    });
    if (toc && !heads.length) toc.style.display = 'none';
    var toggle = root.querySelector('.fga-toc__toggle');
    if (toggle) toggle.addEventListener('click', function () {
      var open = toc.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* Progreso de lectura + sección activa + barra fija */
    var bar = document.querySelector('.fga-progress span');
    var sticky = root.querySelector('[data-fga-sticky]');
    var hero = root.querySelector('.fga-hero');
    var ticking = false;
    function onScroll() {
      ticking = false;
      var r = main.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var done = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.3) / (total || 1)));
      if (bar) bar.style.transform = 'scaleX(' + done + ')';
      var current = -1;
      for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top < 140) current = i; }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === current); });
      if (sticky && hero) {
        var past = hero.getBoundingClientRect().bottom < 0;
        var end = r.bottom < window.innerHeight * 0.5;
        var on = past && !end;
        sticky.classList.toggle('is-visible', on);
        document.body.classList.toggle('fga-sticky-on', on);
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    /* Videos: cargan y arrancan al entrar en pantalla, se pausan al salir */
    var vids = root.querySelectorAll('[data-fga-video]');
    vids.forEach(function (fig) {
      var v = fig.querySelector('video');
      var play = fig.querySelector('[data-fga-play]');
      var sound = fig.querySelector('[data-fga-sound]');
      function load() { if (!v.src && v.dataset.src) v.src = v.dataset.src; }
      function start() { load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      v.addEventListener('playing', function () { fig.classList.add('is-playing'); });
      v.addEventListener('pause', function () { fig.classList.remove('is-playing'); });
      play.addEventListener('click', start);
      v.addEventListener('click', function () { if (v.paused) start(); else v.pause(); });
      sound.addEventListener('click', function () {
        v.muted = !v.muted;
        fig.classList.toggle('is-sound', !v.muted);
        sound.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
        if (v.paused) start();
      });
      if (!reduced && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.5) start();
            else if (!v.paused) { v.pause(); }
          });
        }, { threshold: [0, 0.5] }).observe(fig);
      }
    });

    /* Compartir */
    var share = root.querySelector('[data-fga-share]');
    if (share) share.addEventListener('click', function () {
      var url = share.dataset.url, label = share.querySelector('span');
      if (navigator.share) { navigator.share({ title: share.dataset.title, url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () {
        var old = label.textContent; label.textContent = 'Link copied';
        setTimeout(function () { label.textContent = old; }, 2200);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
